module.exports = {"sld:ColorMapEntry":[{"quantity":0.001,"color":"#0074ad","label":"<=0.01"},{"quantity":0.03,"color":"#9dc4b5","label":"0.01-0.03"},{"quantity":0.06,"color":"#e6efc3","label":"0.03-0.06"},{"quantity":0.1,"color":"#ffe89e","label":"0.06-0.1"},{"quantity":0.15,"color":"#f5af7f","label":"0.1-0.15"},{"quantity":100,"color":"#ed6d32","label":">0.15"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/catastrophic_wheat.json
// module id = n0Oy
// module chunks = 171